<template>
  <div class="child_">
    <a-form
      layout="horizontal"
      class="horizontal_item_"
      :form="form"
      @submit="zbSubmit"
    >
    </a-form>
  </div>
</template>

<script>
const dictOptions = window.utilsdictOptions;
import moment from "moment";
const tableData = [];
export default {
  data() {
    return {
      tableData,
      insureType: "",
      fValue: {
        radioGroup: "02",
        checkBox: ["02"],
      },
      form: this.$form.createForm(this),
      includes03: false, //雾霾营业中断->是否展示：需要赠险
      includes01: false, //冠状病毒营业中断->是否展示：需要赠险
      includes04: false, //需要赠险->是否展示：被保人
      showByRadio: true, //根据发票类型展示
      provinceOptions: dictOptions.addressOptions, //地址选择
      projectCityOptions: [],
      checkList: ["02"],
      planOffsetDay: 0,
      rangeConfig: {
        rules: [{ required: true, message: "请选择时间!" }],
      },
      insureMax: "",
      xgzhongduan: false,
      wmzhongduan: false,
      yiwai: false,
      policyPlanCode: "",
      fangAnCode: "",
      userParams: {},
      policyRiskInfo: [],
      ywbm: 5,
      nationAreaType: "",
      publicParms: {
        invoicePrintType: "",
        wenEmail: "",
        receiveEmail: "",
        cord: "",
        yeEmail: "",
        menberNum: "",
        holderName: "",
        pactType: "",
        destination1: 0,
        destination2: 0,
        destination3: 0,
        destination4: 0,
        destination5: 0,
        effectiveDate: "",
        expireDate: "",
        iptSumAmountFirst: 0,
        idNumber: "", //证件号
        birthDate: "", //出生日期
        idType: "", //身份证类型
        categoryid: "I", //投保人类型
      },
      totalPremium: 0,
    };
  },
  watch: {
    publicParms: {
      handler: function (news) {
        if (news.effectiveDate) {
          //触发日期重新计算
          this.judgeData(news.effectiveDate);
        }
        if (!news.submit) {
          //非保存条件  计算保费
          this.onChange(news.checkedList || []);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$bus.$on("busPublicParms1", (data) => {
      
      this.publicParms = data;
      if (this.publicParms.effectiveDate) {
        this.judgeData(this.publicParms.effectiveDate);
      }
      if (data.destination) {
        //非保存条件  计算保费
        this.onChange(data.checkedList || []);
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("busPublicParms1");
  },
  created() {
    const { u, p } = this.$route.query;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  methods: {
    moment,
    judgeData(value) {
      if (moment(value).isBefore(new Date())) {
        return moment(new Date()).add(1, "day");
      } else {
        return value;
      }
    },
    judgeEffectiveDate(value, effectiveDate) {
      if (moment(value).isBefore(moment(effectiveDate).add(3, "year"))) {
        return value;
      } else {
        return moment(effectiveDate).add(3, "year");
      }
    },
    onChange(checkedValues) {
      this.yiwai = false;
      if (checkedValues.includes("01")) {
        // this.xgzhongduan = true;
      } else {
        this.xgzhongduan = false;
      }
      if (checkedValues.includes("03")) {
        this.wmzhongduan = true;
      } else {
        this.wmzhongduan = false;
      }

      this.zhongduan(checkedValues);
    },
    zhongduan() {
      this.getProductCode();
      this.setFangAnCode();
    },
    getProductCode() {
      if (this.yiwai && this.wmzhongduan) {
        // 租金补偿+意外+雾霾
        this.policyPlanCode = "LBPLAU30980002137";
      } else if (this.wmzhongduan) {
        // 租金补偿+雾霾
        this.policyPlanCode = "LBPLAU309800037";
      } else {
        // 租金补偿
        this.policyPlanCode = "LBPLAN309800007";
      }
    },
    setFangAnCode() {
      if (this.wmzhongduan) {
        // 租金补偿+雾霾营业中断
        this.fangAnCode = "LBPLAU309800037";
      } else {
        this.fangAnCode = "LBPLAN309800007"; // 租金补偿
      }
      this.calculate();
    },
    saveParms() {
      let value = this.form.getFieldsValue();
      delete value.expireDate;
      delete value.effectiveDate;
      value.salInsuredList = this.tableData;
      window.sessionStorage.setItem("parmsData", JSON.stringify(value));
    },
    updateParms() {
      var params = window.sessionStorage.getItem("parmsData");
      var value = JSON.parse(params);
      this.insureType = value.salPolicyHolder.type;
      // this.form.setFieldsValue({
      //   ...value
      // });
      this.tableData = value.salInsuredList || [];
    },

    idTypeChange() {
      // this.form.setFieldsValue({ salPolicyHolder: { idNumber: "" } });
    },
    calculate() {
      if ((this.publicParms.destination || 0) == 0) {
        return;
      }
      //保费计算
      let data = {
        RentingBjoece: (this.publicParms.destination || 0) - 0,
        fangAnCode: this.fangAnCode,
      };
      this.$api.zhongliGetCelPrice(data).then((res) => {
        if (res.data.returnData) {
          let param = {};
          let planJson = res.data.returnData[0];
          param.plan001 = planJson["001"];
          param.plan003 = planJson["003"];
          param.plan004 = planJson["004"];
          param.plan005 = planJson["005"];
          param.plan006 = planJson["006"];
          param.plan007 = planJson["007"];
          param.plan008 = planJson["008"];
          param.plan009 = planJson["009"];
          param.plan010 = planJson["010"];
          param.plan011 = planJson["011"];
          param.plan012 = planJson["012"];
          param.plan0022 = planJson["0022"];
          param.plan0021 = planJson["0021"];
          // this.form.setFieldsValue({
          //   salPolicy: {
          //     totalPremium: planJson["003"]
          //   },
          //   ...param
          // });
          this.totalPremium = Number(planJson["003"]);
          this.$emit("totalPremium", planJson["003"]);
          this.initRiskInfo(param);
        }
      });
    },
    initRiskInfo(param) {
      this.policyRiskInfo = []; //清空险种信息
      // 添加险种
      this.addRiskInfo(
        param.plan004,
        param.plan001,
        "15M00075,00089",
        "LBPLAN309800007"
      ); // 租金补偿
      if (this.wmzhongduan) {
        // 雾霾
        this.addRiskInfo(
          param.plan005,
          param.plan0021,
          "01S00065,00603",
          "LBPLAU309800037"
        ); // 雾霾
      }

      if (this.yiwai) {
        // 意外
        this.addYiWaiRiskInfo();
      }
    },
    addYiWaiRiskInfo() {
      this.addRiskInfo("3000", "1", "27S00115,00523", "LBPLAU309800021");
      this.addRiskInfo("300000", "1", "27S00114,00524", "LBPLAU309800021");
      this.addRiskInfo("100000", "1", "27M0002,0059", "LBPLAU309800021");
      this.addRiskInfo("100000", "1", "27M0002,0060", "LBPLAU309800021");
    },
    addRiskInfo(amount, premiumAmt, riskCode, dutyCode) {
      var addItem = {
        amount: amount,
        premiumAmt: premiumAmt,
        riskCode: riskCode,
        dutyCode: dutyCode,
      };
      this.policyRiskInfo.push(addItem);
    },
    //表单提交
    zbSubmit() {
      let valid = false;
      let totalPremium = 0;
      let publicParms = JSON.parse(sessionStorage.getItem("publicParms"));
      this.onChange(publicParms.checkedList || []);
      this.form.validateFields((err) => {
        if (!err) {
          valid = true;
          let publicParms = JSON.parse(sessionStorage.getItem("publicParms"));
          let effectiveDate = this.judgeData(publicParms.effectiveDate);
          let expireDate = this.judgeEffectiveDate(
            publicParms.expireDate,
            effectiveDate
          );
          let tickets = publicParms.originalTickets;
          totalPremium =
            publicParms.tickets > 0
              ? publicParms.tickets - 0 + (this.totalPremium - 0)
              : this.totalPremium;
          let params = {};
          params.salPolicy = {
            nationAreaType: publicParms.ywbm,
            holderName: publicParms.holderName,
            bankName: publicParms.holderName,
            effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
            expireDate: moment(expireDate).format("YYYY-MM-DD"),
            creator: this.userParams.userId,
            productCode: "LBFEIBUX", //费补险
            planCode: this.policyPlanCode,
            noticeno: publicParms.cord,
            mailno: publicParms.pactType,
            bracket: this.brackePercentage1,
            policyPostName: publicParms.policyPostName,
            destination: publicParms.destination,
            tickets: tickets, //汇款金额
            totalPremium: totalPremium,
            loanBeginTime: moment(publicParms.effectiveDate).format(
              "YYYY-MM-DD"
            ),
            loanEndTime: moment(publicParms.expireDate).format("YYYY-MM-DD"),
          };
          params.salPolicyHolder = {
            type: publicParms.categoryid,
            name: publicParms.holderName,
            idType: publicParms.idType,
            idNumber: publicParms.idNumber || "110101198001010061",
            telephone: publicParms.invoiceLxdh,
            birthDate: publicParms.birthDate
              ? moment(publicParms.birthDate).format("YYYY-MM-DD")
              : "1980-01-01",
            invoicetitle: `${publicParms.wenEmail.replace(
              /\s+/g,
              ""
            )}@chailease.com.cn`,
            email: publicParms.receiveEmail.replace(/\s+/g, ""),
            invoiceno: `${publicParms.yeEmail.replace(
              /\s+/g,
              ""
            )}@chailease.com.cn`,
            useidnum: publicParms.menberNum,
            addresscode: "120107,000000,0001,0001",
            invoiceprinttype: publicParms.invoicePrintType,
            shopsname: publicParms.invoiceStart,
            taxpayercertificateno: publicParms.invoiceSbh,
            billingdepositbank: publicParms.invoiceKhh,
            billingdepositbankaccount: publicParms.invoiceNumber, //开户行账号
            billingaddress: publicParms.invoiceKpdz,
            fastmailtel: publicParms.invoiceLxdh,
            fastmailaddress: publicParms.invoiceYjdz,
            billingphone: publicParms.invoiceKpdh, //开票电话
            fastmailname: publicParms.invoiceLxr, //联系人
          };
          params.salInsuredList = [];
          params.riskInfos = this.policyRiskInfo;
          

          // this.$api.saveOrder(params).then(r => {
          //   if (r.data.returnCode == "00") {
          //     this.twoSave = false;
          //     this.$emit("policyId", r.data.content);
          //   } else {
          //     this.$emit("save", false);
          //   }
          // }).catch(r => { this.$emit("save", false) });
        }
      });
      if (valid) {
        const saveData = {
          policyPlanCode: this.policyPlanCode,
          bracket: this.brackePercentage1,
          tickets: publicParms.originalTickets, //汇款金额
          totalPremium: totalPremium,
          salInsuredList: [],
          riskInfos: this.policyRiskInfo,
        };
        return saveData;
      }
    },
    resetForm() {
      this.form.resetFields();
    },
    checkFields() {
      this.form.validateFields((err) => {
        if (!err) {
          this.$emit("checked", true);
        } else {
          this.$emit("checked", false);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
$themeC: rgba(254, 143, 45, 1);

.child_ {
  .mrg_r12_ {
    margin-right: 12px;
  }

  .w200_ {
    width: 200px;
  }

  .w120_ {
    width: 120px;
  }

  .wid_150 {
    width: 150px;
  }

  .marL_10 {
    margin-left: 10px;
  }

  .title_ {
    margin: 30px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cutleft_ {
      font-size: 16px;
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      // width: 10%;
    }

    .cutoff_ {
      // width:90%;
      flex: 1;
      height: 5px;
      background: #f0f0f0;
    }
  }

  .operation {
    text-align: center;
  }

  .operation span {
    display: inline-block;
    background-color: #fe8f2d;
    color: #fff;
    border-radius: 3px;
    padding: 3px 10px;

    &:last-child {
      margin-left: 20px;
    }
  }

  .btn_list {
    display: flex;
    justify-content: center;

    .btn_ {
      margin: 19px;
      border: 1px solid $themeC;
      width: 150px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;

      .btn_a {
        flex: 1;
        text-align: center;
        color: $themeC;
      }
    }
  }

  .btn_color {
    background: $themeC;
    border: 1px solid $themeC;
  }
}
</style>